<template>
  <div class="container-fluid col-12 col-lg-10 offset-lg-1">
    <div v-for="(groups, groupname, index) in posters">
      <div class="alert bg-secondary pl-0 pr-0 mb-1 mt-2" v-on:click="setOpenCollapse('group' + index)">
        <button class="btn btn-link font-weight-bold text-left collapsed" type="button" data-toggle="collapse"
                :data-target="'#group'+index"
                aria-expanded="false" :aria-controls="'group' + index">
          <span class="when-opened"> <icon :icon="['fad', 'chevron-down']"/> </span>
          <span class="when-closed"> <icon :icon="['fad', 'chevron-right']"/> </span>
          {{ groupname }}
        </button>
      </div>
      <div class="collapse" :id="'group' + index">
        <Wall :poster="poster" v-for="(poster) in groups" v-if="!isMobile()"/>
        <WallMobile :poster="poster" v-for="(poster) in groups" v-if="isMobile()"/>
      </div>
    </div>
  </div>
</template>

<script>
import Wall from "../items/Wall";
import WallMobile from "../items/WallMobile";
import {mapState} from 'vuex'

const VueScrollTo = require('vue-scrollto');

export default {
  components: {Wall, WallMobile},
  data() {
    return {}
  },
  computed: {
    ...mapState(
        ['openCollapse']
    ),
  },
  props: ['posters'],
  name: "groupedWall",
  methods: {
    setOpenCollapse: function (collapse) {
      this.$store.state.openCollapse = collapse;
    },
    scrollTo: function () {
      let scrollspeed = 500;
      if (this.$browserDetect.meta.name === 'Chrome') {
        scrollspeed = 1500;
      }
      VueScrollTo.scrollTo('#poster' + this.$route.params.poster, scrollspeed, {easing: 'ease-in'});
    },
  },
  created() {
    if (!this.$store.state.ratings.length) {
      this.$store.dispatch('GET_ALL_RATINGS');
    }
  },
  mounted() {
    if (this.$store.state.openCollapse.length > 0) {
      $('#' + this.$store.state.openCollapse).collapse('show');
    }
    if (this.$route.params.poster > 0) {
      this.scrollTo();
    }
    this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'view/' + this.$store.state.mode.displayType, 'grouped:' + this.$store.state.mode.grouped.status);
  }
}
</script>

<style scoped>

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
